module.exports = __webpack_public_path__ + "static/img/renwutongbu.436fe34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/renwutongbu.png
// module id = RPj0
// module chunks = 24